import { createFileRoute, redirect } from "@tanstack/react-router";

// History is a tab of the training hub; its own address (the breadcrumb's link) leads there.
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders, so the crumb comes from the layout route
export const Route = createFileRoute("/(private)/training/history/")({
  beforeLoad: () => {
    throw redirect({ to: "/training", search: { tab: "history" } });
  },
});
